import React from 'react';
import customOrderService from '../../../services/customOrderService';

/**
 * ✅ ATELIER: Timeline visuelle du workflow de la commande.
 */
const OrderStatusTimeline = ({ currentStatus }) => {
  const workflow = ['RECEIVED', 'CUTTING', 'SEWING', 'FITTING', 'READY', 'DELIVERED'];

  // Si annulée, on affiche un état spécial
  if (currentStatus === 'CANCELLED') {
    return (
      <div className="text-center py-3">
        <Badge_like color="#dc3545">❌ Commande annulée</Badge_like>
      </div>
    );
  }

  const currentIdx = workflow.indexOf(currentStatus);

  return (
    <div className="order-timeline">
      <div className="timeline-track">
        {workflow.map((status, idx) => {
          const info = customOrderService.getStatusInfo(status);
          const isCompleted = idx < currentIdx;
          const isCurrent = idx === currentIdx;
          const isPending = idx > currentIdx;

          let stateClass = 'step-pending';
          if (isCompleted) stateClass = 'step-completed';
          if (isCurrent) stateClass = 'step-current';

          return (
            <React.Fragment key={status}>
              <div className={`timeline-step ${stateClass}`}>
                <div className="step-icon">
                  {isCompleted ? '✓' : info.icon}
                </div>
                <div className="step-label">{info.label}</div>
              </div>
              {idx < workflow.length - 1 && (
                <div
                  className={`timeline-connector ${
                    idx < currentIdx ? 'connector-completed' : 'connector-pending'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <style>{`
        .order-timeline {
          padding: 1rem 0;
        }

        .timeline-track {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        }

        .timeline-step {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
          position: relative;
          z-index: 2;
          flex: 0 0 auto;
        }

        .step-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          font-weight: bold;
          border: 2px solid;
          background: white;
          transition: all 0.3s;
        }

        .step-label {
          font-size: 0.7rem;
          text-align: center;
          font-weight: 500;
          white-space: nowrap;
        }

        /* Étapes terminées */
        .step-completed .step-icon {
          background: #10b981;
          border-color: #10b981;
          color: white;
        }
        .step-completed .step-label {
          color: #10b981;
        }

        /* Étape courante */
        .step-current .step-icon {
          background: #3b82f6;
          border-color: #3b82f6;
          color: white;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
        }
        .step-current .step-label {
          color: #3b82f6;
          font-weight: 700;
        }

        /* Étapes à venir */
        .step-pending .step-icon {
          background: #f1f5f9;
          border-color: #cbd5e1;
          color: #94a3b8;
        }
        .step-pending .step-label {
          color: #94a3b8;
        }

        /* Connecteurs */
        .timeline-connector {
          flex: 1;
          height: 2px;
          min-width: 20px;
          margin: 0 4px;
          margin-bottom: 1.5rem;
        }

        .connector-completed {
          background: #10b981;
        }

        .connector-pending {
          background: #e2e8f0;
        }

        /* Responsive */
        @media (max-width: 576px) {
          .step-icon {
            width: 28px;
            height: 28px;
            font-size: 0.75rem;
          }
          .step-label {
            font-size: 0.6rem;
          }
        }
      `}</style>
    </div>
  );
};

// Petit composant interne pour l'état "annulée"
const Badge_like = ({ color, children }) => (
  <span
    style={{
      background: color,
      color: 'white',
      padding: '0.5rem 1rem',
      borderRadius: '999px',
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.3rem'
    }}
  >
    {children}
  </span>
);

export default OrderStatusTimeline;